import { create } from 'zustand';
import type { PopulationBlob } from '../lib/blobLoader';

type BlobState = {
  blob: PopulationBlob | null;
  loading: boolean;
  error: Error | null;
  setBlob: (blob: PopulationBlob | null) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: Error | null) => void;
};

export const useBlobStore = create<BlobState>((set) => ({
  blob: null,
  loading: false,
  error: null,
  setBlob: (blob) => set({ blob }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
}));
